import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { enabledProvidersSelector } from "../../../common/selectors/billing-analytics/enabled-providers/enabledProvidersSelector";

export const resourceExplorerMinDateFixedCacheKey = `postUsersMeOrganisationsCurrentMinimumAvailableDate-fixed-cache-key`;

export const getResourceExplorerMinAvailableDateThunk = createAsyncThunk(
  "resourceExplorer/getResourceExplorerMinAvailableDate",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;

    const enabledProviders = enabledProvidersSelector(state);
    const enabledProvidersArr = Array.from(enabledProviders);

    const { postUsersMeOrganisationsCurrentMinimumAvailableDate } =
      cloudChiprApi.endpoints;

    await dispatch(
      postUsersMeOrganisationsCurrentMinimumAvailableDate.initiate(
        {
          body: { cloud_providers: enabledProvidersArr },
        },
        { fixedCacheKey: resourceExplorerMinDateFixedCacheKey },
      ),
    ).unwrap();
  },
);
